import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[i-request-view-content]',
})
export class RequestViewContentDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
